module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "hello"
    }
  }, [_c('div', {
    staticClass: "swiper-container gallery-top swiper-container-horizontal"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.lbt), function(item, i) {
    return _c('div', {
      staticClass: "swiper-slide",
      style: ({
        backgroundImage: 'url(' + _vm.lbt[i].image_url + ')'
      })
    })
  }))]), _vm._v(" "), _c('div', {
    staticClass: "swiper-pagination"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('section', {
    staticClass: "hs-box"
  }, [_vm._l((_vm.numList.title), function(item, index) {
    return _c('p', {
      staticStyle: {
        "display": "none"
      }
    }, [_c('span', {
      staticClass: "numTitle"
    }, [_vm._v(_vm._s(item))]), _vm._v(" "), _c('span', {
      staticClass: "numNum"
    }, [_vm._l((_vm.numList.num[index]), function(ite, i) {
      return _c('label', {
        class: 'numListTu' + index + ''
      }, [_vm._v(_vm._s(ite))])
    }), _vm._v(" 条\n      ")], 2), _vm._v(" "), _c('span', {
      staticClass: "numTime"
    }, [_vm._v("当天时间" + _vm._s(_vm.numList.time) + "  累计血糖数据")])])
  }), _vm._v(" "), _vm._m(2)], 2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('section', {
    staticClass: "hs-box-s"
  }, [_vm._m(4), _vm._v(" "), _vm._l((_vm.companyNews), function(item, i) {
    return _c('a', {
      attrs: {
        "target": "_blank",
        "href": "" + _vm.host + "/site/detail.html?id=" + _vm.companyNews[i].id + ""
      }
    }, [_c('p', {
      staticClass: "hsDynamicLi"
    }, [_c('img', {
      staticClass: "hsDynamicTu",
      attrs: {
        "src": "" + _vm.host + "" + _vm.companyNews[i].title_img + ""
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "hsDynamicLiText"
    }, [_c('label', {
      staticClass: "hsDynamicTop"
    }, [_vm._v(_vm._s(_vm.companyNews[i].title))]), _vm._v(" "), _c('label', {
      staticClass: "hsDynamicBottom"
    }, [_vm._v(_vm._s(_vm.companyNews[i].summary))])])])])
  })], 2), _vm._v(" "), _c('section', {
    staticClass: "hs-box"
  }, [_vm._m(5), _vm._v(" "), _c('ul', {
    staticClass: "box61"
  }, [_c('li', {
    staticClass: "box61HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-1.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box62HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-3.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box61HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-4.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box62HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-7.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box61HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-6.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box62HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-11.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box61HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-2.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box62HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-9.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box61HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-5.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box62HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-8.png) no-repeat center center;")
  }), _vm._v(" "), _c('li', {
    staticClass: "box61HsTu",
    style: ("background: url(" + _vm.host + "/html/dist/site/6-10.png) no-repeat center center;")
  })])]), _vm._v(" "), _vm._m(6)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hs-box"
  }, [_c('p', {
    staticClass: "introduction"
  }, [_vm._v("核心功能"), _c('br'), _c('label', [_vm._v("the core function")])]), _vm._v(" "), _c('ul', {
    staticClass: "box1-uls"
  }, [_c('li', [_c('div', {
    staticClass: "ul-div"
  }, [_c('p', {
    staticClass: "ul-p",
    staticStyle: {
      "background": "rgb(10, 202, 177)"
    }
  }, [_c('img', {
    staticClass: "boxImg",
    attrs: {
      "src": require("../../site/1-14.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title1",
    staticStyle: {
      "color": "rgb(10, 202, 177)"
    }
  }, [_vm._v("糖尿病诊所")]), _vm._v(" "), _c('span', {
    staticClass: "content1",
    staticStyle: {
      "color": "rgb(10, 202, 177)"
    }
  }, [_vm._v("国内首个1型糖尿病"), _c('br'), _vm._v("专科诊所依据并遵从“循证”"), _c('br'), _vm._v("的医学诊疗方法患者提供国"), _c('br'), _vm._v("际标准的医疗服务")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ul-div"
  }, [_c('p', {
    staticClass: "ul-p",
    staticStyle: {
      "background": "rgb(241, 158, 194)"
    }
  }, [_c('img', {
    staticClass: "boxImg",
    attrs: {
      "src": require("../../site/1-11.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title1",
    staticStyle: {
      "color": "rgb(241, 158, 194)"
    }
  }, [_vm._v("线上患教服务")]), _vm._v(" "), _c('span', {
    staticClass: "content1",
    staticStyle: {
      "color": "rgb(241, 158, 194)"
    }
  }, [_vm._v("便捷的线上随访医院"), _c('br'), _vm._v("已成功帮助上千糖友完成线上患教工作"), _c('br'), _vm._v("医生+患教师教你进阶血糖教育"), _c('br'), _vm._v("把“神秘”控糖技能告诉你")])])]), _vm._v(" "), _c('li', [_c('div', {
    staticClass: "ul-div"
  }, [_c('p', {
    staticClass: "ul-p",
    staticStyle: {
      "background": "rgb(247, 202, 81)"
    }
  }, [_c('img', {
    staticClass: "boxImg",
    attrs: {
      "src": require("../../site/1-12.png")
    }
  })]), _vm._v(" "), _c('span', {
    staticClass: "title1",
    staticStyle: {
      "color": "rgb(247, 202, 81)"
    }
  }, [_vm._v("同伴互助控糖")]), _vm._v(" "), _c('span', {
    staticClass: "content1",
    staticStyle: {
      "color": "rgb(247, 202, 81)"
    }
  }, [_vm._v("分享并互评每天的血糖"), _c('br'), _vm._v("学习控糖乐此不疲，温暧有爱"), _c('br'), _vm._v("这是1型糖友最温暖的“朋友圈”")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hs-box-s"
  }, [_c('p', {
    staticClass: "introduction"
  }, [_vm._v("其它功能"), _c('br'), _c('label', [_vm._v("the other features")])]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLi3"
  }), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiTitle"
  }, [_vm._v("血糖日历")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiText"
  }, [_vm._v("回顾过去每月控糖成绩单"), _c('br'), _vm._v("在进步中成长帮助90%"), _c('br'), _vm._v("的糖友有效降低糖化血红蛋白"), _c('br'), _vm._v("糖友的潜能大大滴")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLi4"
  }), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiTitle"
  }, [_vm._v("同城糖友聚会")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiText"
  }, [_vm._v("无论您在中国哪个角落总会有一"), _c('br'), _vm._v("场离您家最近的糖友聚会"), _c('br'), _vm._v("让同城的糖友从APP走到线下"), _c('br'), _vm._v("从此同城控糖再也不孤单")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLi5"
  }), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiTitle"
  }, [_vm._v("音频漫画视频专题")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiText"
  }, [_vm._v("琳琅满目的学习方式充满"), _c('br'), _vm._v("情感的糖友故事/科普内容"), _c('br'), _vm._v("多姿多彩的漫画、视频"), _c('br'), _vm._v("满足不同糖友的需求")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLi6"
  }), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiTitle"
  }, [_vm._v("游戏学知识")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiText"
  }, [_vm._v("控糖知识也能过关闯将？"), _c('br'), _vm._v("还能与同伴试比高？"), _c('br'), _vm._v(" 更能获取奖励？"), _c('br'), _vm._v("没错，控糖不再枯燥。")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLi7"
  }), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiTitle"
  }, [_vm._v("自我管理")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiText"
  }, [_vm._v("细分年龄段血糖控制目标和不"), _c('br'), _vm._v("同治疗方案，内置血糖"), _c('br'), _vm._v("场景智能提示，教你"), _c('br'), _vm._v("听身体的声音，做自己的医生")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLi8"
  }), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiTitle"
  }, [_vm._v("卫教随访")]), _vm._v(" "), _c('p', {
    staticClass: "hsBoxLiText"
  }, [_vm._v("院外随访，数据跟踪，精确"), _c('br'), _vm._v("问卷，复诊报告，"), _c('br'), _vm._v("医疗卫教人员提高"), _c('br'), _vm._v("患者依从性的好帮手！")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "diTu"
  }, [_c('span', [_c('label', [_vm._v("中国1型糖尿病患者分布")]), _c('br'), _vm._v("截止至2017年12月12日 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "huiSe1"
  }, [_c('section', {
    staticClass: "hs-box"
  }, [_c('p', {
    staticClass: "hs-app"
  }, [_vm._v("糖糖圈手机客户端")]), _vm._v(" "), _c('p', {
    staticClass: "hs-appText"
  }, [_vm._v("\n      国内的1型糖友互助"), _c('br'), _vm._v("\n      交流平台，有了它，糖友不再无助、"), _c('br'), _vm._v("\n      不再孤独迷茫！你也加入吧..."), _c('br')]), _vm._v(" "), _c('p', {
    staticClass: "hs-appTu"
  }), _vm._v(" "), _c('a', {
    staticClass: "box6-14",
    attrs: {
      "href": "http://a.app.qq.com/o/simple.jsp?pkgname=so.ttq"
    }
  }, [_vm._v("糖糖圈下载")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "introduction"
  }, [_vm._v("公司动态"), _c('br'), _c('label', [_vm._v("company dynamics")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "introduction"
  }, [_vm._v("合作伙伴"), _c('br'), _c('label', [_vm._v("cooperative partner")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "hs-box-s"
  }, [_c('p', {
    staticClass: "hs-logo2"
  }), _vm._v(" "), _c('p', {
    staticClass: "hs-end"
  }, [_vm._v("\n      爱宝惟生物科技有限公司版权所有\n      "), _c('span', {
    staticStyle: {
      "font-size": "14px",
      "margin-top": "15px"
    }
  }, [_vm._v("Copyright @ 2014-2024 aibaowei.All Rights Reserved"), _c('br'), _c('a', {
    attrs: {
      "href": "http://www.beian.miit.gov.cn"
    }
  }, [_vm._v("粤ICP备14072944号")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6c3bab78","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Hello.vue
// module id = 189
// module chunks = 1